
// This file contains mock data for Google Maps API
// It's used as a fallback when the real API is unavailable

export interface MockGooglePlace {
  place_id: string;
  name: string;
  formatted_address: string;
  vicinity: string;
  geometry?: { // Made geometry optional
    location: {
      lat: () => number;
      lng: () => number;
    }
  };
  types: string[];
}

// Generate mock Google Places results
export const generateMockPlaces = (query: string): MockGooglePlace[] => {
  return [
    {
      place_id: `google-${query}-1`,
      name: `${query} Business`,
      formatted_address: '123 Main St, Anytown, CA 94040',
      vicinity: 'Anytown',
      geometry: {
        location: {
          lat: () => 37.4219999,
          lng: () => -122.0840575
        }
      },
      types: ['business', 'establishment']
    },
    {
      place_id: `google-${query}-2`,
      name: `${query} Services`,
      formatted_address: '456 Market St, Anytown, CA 94041',
      vicinity: 'Anytown',
      geometry: {
        location: {
          lat: () => 37.4300999,
          lng: () => -122.0900575
        }
      },
      types: ['business', 'establishment']
    },
    {
      place_id: `google-${query}-3`,
      name: `${query} Professional Corp`,
      formatted_address: '789 Oak St, Anytown, CA 94042',
      vicinity: 'Anytown',
      geometry: {
        location: {
          lat: () => 37.4250999,
          lng: () => -122.0870575
        }
      },
      types: ['business', 'establishment']
    }
  ];
};

// Mock implementation of the Google Places API
export const mockGooglePlaces = {
  search: (query: string): MockGooglePlace[] => {
    return generateMockPlaces(query);
  },
  
  getDetails: (placeId: string) => {
    if (placeId && placeId.startsWith('google-')) {
      const parts = placeId.split('-');
      const query = parts.length > 1 ? parts[1] : '';
      
      return {
        name: `${query} Business`,
        phone: '(555) 123-4567',
        email: '',
        address: '123 Main St',
        city: 'Anytown',
        state: 'CA',
        zip: '94040',
        website: 'https://example.com',
        founded: '2010',
        industry: 'Business Services',
        coordinates: {
          latitude: 37.4219999,
          longitude: -122.0840575
        }
      };
    }
    
    return null;
  }
};
